export default "__VITE_ASSET__CqaNUYos__"